
export class AbmEncrypt {
    // |______|__ro|
    public static basicEncrypt(pwd: string): string {
        let encrypt = '';

        let sumCode = 0;
        for (let i = 0; i < pwd.length; i++) {
            sumCode += pwd.charCodeAt(i);
        }
        const offset = sumCode % 10;

        for (let i = 0; i < pwd.length; i++) {
            encrypt += String.fromCharCode(pwd.charCodeAt(i) + (i % 2 === 0 ? offset : -offset));
        }
        return encrypt + pwd.charAt(0) + pwd.charAt(pwd.length - 1) + Math.round(Math.random() * 10) + offset;
    }

    public static basicDecrypt(enc: string): string {
        if (enc.length < 6) {
            console.error('Not a encrypt format: ' + enc);
            return null;
        }
        const encrypted = enc.substring(0, enc.length - 4);
        const offset = +enc.charAt(enc.length - 1);

        let decrypt = '';

        for (let i = 0; i < encrypted.length; i++) {
            decrypt += String.fromCharCode(encrypted.charCodeAt(i) + (i % 2 === 0 ? -offset : offset));
        }
        return decrypt;
    }
}
